import dayjs from 'dayjs';
import Box, { type BoxProps } from '@liquidweb-dev/undercurrent/Box';
import Card from '@liquidweb-dev/undercurrent/Card';
import CardHeader from '@liquidweb-dev/undercurrent/CardHeader';
import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

import ConfirmFooter from './ConfirmFooter';

export interface AddonWrapperProps extends StackProps {
	headerLabel?: string;
}

export const AddonIconBox = ({ sx, children, ...rest }: BoxProps) => {
	return (
		<Box
			display="flex"
			width="64px"
			height="64px"
			justifyContent="center"
			alignItems="center"
			sx={combineSx(
				({ borderRadius }) => ({ borderRadius: borderRadius.rounded }),
				sx,
			)}
			{...rest}
		>
			{children}
		</Box>
	);
};

const AddonWrapper = ({
	children,
	headerLabel = 'Selected Service',
	...rest
}: AddonWrapperProps) => {
	return (
		<Stack {...rest}>
			<Card sx={{ zIndex: 1, width: '100%' }}>
				<CardHeader
					title={
						<Stack
							direction={{ xs: 'column', sm: 'row' }}
							justifyContent="space-between"
							alignItems={{ xs: 'flex-start', sm: 'center' }}
							gap={{ xs: 100 }}
							width="100%"
						>
							<Typography variant="label-lg" fontWeight={500}>
								{headerLabel}
							</Typography>
							<Typography
								variant="label-lg"
								sx={({ vars }) => ({
									color: vars.palette.uc.text.weak,
								})}
							>
								Cancellation date:{' '}
								<Typography
									variant="label-lg"
									sx={({ vars }) => ({
										color: vars.palette.uc.text.main,
									})}
								>
									{dayjs().format('LL')}
								</Typography>
							</Typography>
						</Stack>
					}
				/>

				<Box
					sx={{
						position: 'relative',
						display: 'flex',
						flexDirection: 'column',
						gap: 200,
						paddingX: 200,
						paddingY: 400,
					}}
				>
					{children}
				</Box>
			</Card>
			<ConfirmFooter />
		</Stack>
	);
};

export default AddonWrapper;
